export const WHATSAPP_LINK = "https://wa.me/919277800469?text=Hi%20Zeltaa%2C%20I%27d%20like%20to%20book%20a%20demo.";
export const RADAGENT_WA_LINK = "https://wa.me/919277800469?text=Hi%2C%20I%27d%20like%20a%20RadAgent%20demo%20for%20my%20diagnostic%20centre.";
export const RADAGENT_URL = "/radagent";
export const RADSCRIBE_URL = "/radscribe";
export const RADSCRIBE_WA_LINK = "https://wa.me/919277800469?text=Hi%2C%20I%27d%20like%20a%20RadScribe%20demo.";
export const CONTACT_PHONE = "+91 92778 00469";
export const CONTACT_EMAIL = "hi@renewist.com";
